// This is the index File.
import React from 'react';
import Layout from '../components/Layout';
import Img from 'gatsby-image';
import Fade from 'react-reveal/Fade';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Scroll from '../components/Scroll';
import { graphql, Link } from 'gatsby';
import Features from '../components/index/features'
import RequestDemoButton from '../components/RequestDemoButton';
import BookADemoButton from '../components/BookADemoButton';
import '../sass/home.scss';

class IndexPage extends React.Component {
  render() {
    return (
      <Layout>
        <Header />
        <header className="masthead">
          <div className="container h-100">
            <div className="row">
              <div className="col-lg-7 col-md-12 col-sm-12">
                <div className="hero-text">
                  <h2 className="uppercase">
                    The <span className="highlight"> smartest</span>
                  </h2>
                  <h2 className="uppercase">mortgage broker</h2>
                  <h2 className="uppercase">
                    platform <span className="highlight">ever built</span>
                  </h2>
                  <h6 className="mt-5 hero-sub-title">
                    Imagine <span> a seamless lead management platform </span>
                    that could help you do your job. One that talked like you,
                    managed customers like you, even generated leads like you.
                    Now imagine it did all the boring bits that you don’t like
                    doing – collecting documents, sending messages, even
                    scheduling appointments. Wouldn’t that be amazing? Oh wait.
                    Meet Effi. Your new bestfriend which does all the above and
                    more.
                  </h6>
                  <div className="d-flex mt-5 hero-btn">
                    <span>
                      <div className="subscribe-form form-dark">
                        <RequestDemoButton text="Request 14-Day Free Trial" />
                      </div>
                    </span>
                    <span>
                        <a
                          className="btn btn-outline-primary  mb-2 ml-2 request-trial"
                          href='https://calendly.com/d/cm6-mn8-qkt/book-a-demo'
                          target='_blank'
                        >
                          Book Demo
                        </a>
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-lg-5 col-md-12 col-sm-12">
                <div className="hero-img2">
                  <Fade delay={600} bottom={true}>
                    <div className="layer-hero">
                      {/* <img src={heroImg} /> */}
                      <Img
                        fluid={
                          this.props.data.new_hero_image.childImageSharp.fluid
                        }
                        className="img-fluid"
                        alt="Effi Hero Image"
                      />
                    </div>
                  </Fade>
                </div>
              </div>
            </div>

            <Scroll type="id" element="nevermiss">
              <a
                href="#about"
                className="page-scroll scroll-down"
                aria-label="Down Icon"
              >
                <i className="mdi mdi-chevron-down" />
              </a>
            </Scroll>
          </div>
        </header>

        <section id="nevermiss" className="nevermiss section-index">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-sm-12">
                <div className="wrap">
                  <h2 className="mb-5">
                    <span className="highlight">Never Miss</span> A Sales <br />{' '}
                    Opportunity Again
                  </h2>
                  <p>
                    When you can sell anywhere, you grow faster. So as soon as a
                    lead comes into the system, Effi is on the case. Effi uses
                    Artificial intelligence to learn from the best – you. Your
                    customers get a message right away and are prompted to book
                    an appointment. With 2-way calendar sync, Effi effortlessly
                    finds a time that works for both of you and locks it in.
                  </p>
                  <h5 className="highlight2 text-left">
                    And with 24/7 response capability, Effi makes sure you never
                    sleep on a lead.
                  </h5>
                </div>
              </div>
              <div className="col-lg-6 col-sm-12">
                <div className="video-wrapper">
                  <iframe
                    width="100%"
                    height="295"
                    src="https://www.youtube.com/embed/nXBYk-Bdtms"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="coustomer-manage" className="section-index section-home">
          <div className="container">
            <div className="row d-flex justify-content-start">
              <div className="col-lg-6">
                <div className="">
                  <Fade>
                    <div className="wr-img">
                      <Img
                      loading="lazy"
                        fluid={
                          this.props.data.manage_customers.childImageSharp.fluid
                        }
                        className="img-fluid"
                        alt="Never miss a sales opportunity"
                      />
                    </div>
                  </Fade>
                </div>
              </div>
              <div className="col-lg-6 d-flex t-text align-items-center">
                <div>
                  <h2 className="mb-4">
                    Simply <span className="highlight"> Manage </span>
                    <br />
                    Your Customers
                  </h2>
                  <p>
                    Effi is a one-stop to help you engage with your customers
                    and get more done. The more leads you effectively deal with,
                    the more sales you can make. Effi keeps everything you need
                    to know about your leads in one place
                  </p>
                  <br />
                  <ul className='text-left'>
                    <li>Manage your email and SMS conversations</li>
                    <li>View appointments and check the status of documents</li>
                    <li>Easy document upload and bank statement collection</li>
                    <li>
                      2-way portal view to ensure you customers are aligned
                    </li>
                    <li>
                      Automatic redaction of TFN, and document renaming make the
                      whole process silky smooth
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="busuness-in-lead" className="section-index section-home">
          <div className="container">
            <div className="row d-flex justify-content-start flex-column-reverse flex-md-row">
              <div className="col-lg-6 col-12 t-text d-flex align-items-center">
                <div>
                  <h2 className="mb-4">
                    Put Your Business
                    <br />
                    <span className="highlight">In The Lead</span>
                  </h2>
                  <p>
                    You can’t make great sales without great leads. Use your
                    leads and ours. We partner with leading high-traffic home
                    loan comparison websites to give you access to high-quality
                    leads, ensuring new customers are constantly coming through
                    the door. When you’ve got an active lead quota of at least
                    five leads, your profile goes up on the comparison platforms
                    for the whole world to see – those looking for a mortgage
                    anyway. As soon as a lead comes in from them, Effi helps you
                    take care of the rest.
                  </p>
                </div>
              </div>
              <div className="col-lg-6 col-12">
                <div className="">
                  <Fade>
                    <div className="wr-img">
                      <Img
                      loading="lazy"
                        fluid={
                          this.props.data.put_in_lead.childImageSharp.fluid
                        }
                        className="img-fluid"
                        alt="Effi Screenshot"
                      />
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="team-ops" className="section-index section-home">
          <div className="container">
            <div className="row d-flex justify-content-start">
              <div className="col-lg-6 col-12 order-lg-1 order-md-2">
                <div className="">
                  <Fade>
                    <div className="wr-img">
                      <Img
                      loading="lazy"
                        fluid={this.props.data.at_best.childImageSharp.fluid}
                        className="img-fluid"
                        alt="Effi Screenshot"
                      />
                    </div>
                  </Fade>
                </div>
              </div>
              <div className="col-lg-6 col-12 order-lg-2 order-md-1 b-text d-flex align-items-center">
                <div>
                  <h2 className="mb-4">
                    Get Your Team Operating
                    <br />
                    <span className="highlight">At Their Best</span>
                  </h2>
                  <p>
                    Sell Anywhere, Anytime And Deliver Great Customer
                    Experiences
                  </p>
                  <p>
                    Effi uses data and reporting to track and maximize
                    effectiveness. Track broker response times, conversion
                    forecasting, lender approval times, referral performance,
                    customer responses, and so much more.
                    <br />
                    <br />
                    Effi sorts out all the small details to help you see the big
                    picture. Whether your team is big or small, Effi will help
                    them perform like never before.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="virtual-assistant" className="section-index  section-home">
          <div className="container">
            <div className="row d-flex justify-content-start">
              <div className="col-lg-6 col-12 order-lg-1 order-md-2 b-text d-flex align-items-center">
                <div>
                  <h2 className="mb-4">
                    Automate Your SMS Follow-Ups With Our Smartest
                    <br />
                    <span className="highlight"> Virtual Assistant</span>
                  </h2>
                  <p>
                    Do you know SMS has 99% open rate and still mortgage brokers
                    rely on email or phone call to engage their leads? Drive 70%
                    more engagement with lost or less engaged leads through AI-
                    powered SMS conversation and book in instant calendar
                    appointments with reminders, saving you time and money
                    calling each lead. Run SMS campaigns on your leads and watch
                    all customer SMS conversations with our virtual assistant in
                    real time with ability to intervene and respond.
                  </p>
                </div>
              </div>
              <div className="col-lg-6 col-12 order-lg-1 order-md-2">
                <div className="">
                  <Fade>
                    <div className="wr-img">
                      <Img
                      loading="lazy"
                        fluid={this.props.data.sms.childImageSharp.fluid}
                        className="img-fluid"
                        alt="Effi Screenshot"
                      />
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="featured-logo" className="featured-logo">
          <div className="container">
            <div className="row d-flex justify-content-center">
              <div className="col-lg-12">
                <h2 className="text-center mb-5">As Featured In</h2>
                <div className="wrap-logoset">
                  <div className="logo-set">
                    <a>
                      <Img
                        loading="lazy"
                        fixed={this.props.data.logo1.childImageSharp.fixed}
                        alt="Effi Screenshot"
                      />
                    </a>
                    <a>
                      <Img
                        loading="lazy"
                        fixed={this.props.data.logo2.childImageSharp.fixed}
                        alt="Effi Screenshot"
                      />
                    </a>
                    <a>
                      <Img
                        loading="lazy"
                        fixed={this.props.data.logo3.childImageSharp.fixed}
                        alt="Effi Screenshot"
                      />
                    </a>
                    <a>
                      <Img
                        loading="lazy"
                        fixed={this.props.data.logo4.childImageSharp.fixed}
                        alt="Effi Screenshot"
                      />
                    </a>
                    <a>
                      <Img
                        loading="lazy"
                        fixed={this.props.data.logo5.childImageSharp.fixed}
                        alt="Effi Screenshot"
                      />
                    </a>
                    <a>
                      <Img
                        loading="lazy"
                        fixed={this.props.data.logo6.childImageSharp.fixed}
                        alt="Effi Screenshot"
                      />
                    </a>
                    <a>
                      <Img
                        loading="lazy"
                        fixed={this.props.data.logo7.childImageSharp.fixed}
                        alt="Effi Screenshot"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="superbly-price" className="price-section">
          <div className="container">
            <div className="row d-flex justify-content-start">
              <div className="col-lg-6 col-12 order-lg-1 order-md-2">
                <div className="">
                  <Fade>
                    <div className="wr-img">
                      <Img
                      loading="lazy"
                        fluid={
                          this.props.data.pricing_img.childImageSharp.fluid
                        }
                        className="img-fluid"
                        alt="Effi Screenshot"
                      />
                    </div>
                  </Fade>
                </div>
              </div>
              <div className="col-lg-6 col-12 order-lg-2 order-md-1 b-text d-flex align-items-center">
                <div>
                  <h2 className="mb-4">
                    <div>Yep, We're</div>
                    <span className="highlight">Superbly Priced</span>
                  </h2>
                  <p>
                    Effi is available on a monthly subscription basis, starting
                    from $49 plus GST per month. Effi even offers access to
                    conveyancing and insurance.
                  </p>
                  <p>
                    We offer three different levels, for individual brokers to
                    large enterprise- Lite, Full and Enterprise - each of which
                    come at a very competitive price.
                  </p>
                  <p>Check out the features of each level below.</p>
                  <div className="d-flex justify-content-around justify-content-md-start">
                    <Link className="btn btn-primary mb-2" to="/pricing">
                      Get Pricing Detail
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          id="feature"
          className="section-index feature-section feature-section-home"
        >
          <div className="container">
            <h2 className="text-center mt-5 mb-3">
              The Ultimate Platform For Mortgage Brokers.
            </h2>
            <h6 className="text-center">
              Our features help you be more productive and efficient to grow
              your business.
            </h6>
            <div className="row">
              <div className="col-12">
                <Features />
              </div>
            </div>
          </div>
        </section>

        <section
          id="feature"
          className="section-index feature-section-home Get-one-platform"
        >
          <div className="container">
            <h2 className="text-center">
              Get one platform to become a successful modern mortgage broker and
              start growing your business today
            </h2>
            <div className="Get-one-platform_btns">
              <BookADemoButton text="Book Demo" />
              <RequestDemoButton text="Request 14-Day Free Trial" />
            </div>
          </div>
        </section>

        <Footer />
      </Layout>
    );
  }
}

export default IndexPage;

export const query = graphql`
  query {
    phone: file(relativePath: { eq: "hero-image/1.png" }) {
      childImageSharp {
        fluid(maxWidth: 500) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
    section_four: file(relativePath: { eq: "home/leader.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 630, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
    manage_customers: file(relativePath: { eq: "home/Screens/Screen 1.png" }) {
      childImageSharp {
        fluid(maxWidth: 1024, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
    put_in_lead: file(relativePath: { eq: "home/Screens/2.png" }) {
      childImageSharp {
        fluid(maxWidth: 1024, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
    at_best: file(relativePath: { eq: "home/Screens/3.png" }) {
      childImageSharp {
        fluid(maxWidth: 1024, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
    sms: file(relativePath: { eq: "home/Screens/4.png" }) {
      childImageSharp {
        fluid(maxWidth: 1024, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
    pricing_img: file(relativePath: { eq: "happiness1.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 800, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
    member: file(relativePath: { eq: "home/avatar.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 800, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
    andyTran: file(relativePath: { eq: "home/andy-tran.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 800, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
    new_hero_image: file(relativePath: { eq: "hero.png" }) {
      childImageSharp {
        fluid(maxWidth: 740, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
    logo1: file(relativePath: { eq: "logos/australian-broker.png" }) {
      childImageSharp {
        fixed(height: 35, width: 354, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp_noBase64
        }
      }
    }
    logo2: file(relativePath: { eq: "logos/Australian-FinTech.png" }) {
      childImageSharp {
        fixed(height: 35, width: 172, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp_noBase64
        }
      }
    }
    logo3: file(relativePath: { eq: "logos/Mortgage-Standard.png" }) {
      childImageSharp {
        fixed(height: 35, width: 291, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp_noBase64
        }
      }
    }
    logo4: file(relativePath: { eq: "logos/stockhead.png" }) {
      childImageSharp {
        fixed(height: 35, width: 256, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp_noBase64
        }
      }
    }
    logo5: file(relativePath: { eq: "logos/TA-standard.png" }) {
      childImageSharp {
        fixed(height: 35, width: 153, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp_noBase64
        }
      }
    }
    logo6: file(relativePath: { eq: "logos/the-paypers-logo.png" }) {
      childImageSharp {
        fixed(height: 35, width: 139, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp_noBase64
        }
      }
    }
    logo7: file(relativePath: { eq: "logos/ausbiz.png" }) {
      childImageSharp {
        fixed(height: 35, width: 145, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp_noBase64
        }
      }
    }
  }
`;
